var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoAntiscam(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4792 21.6403C20.7785 21.2466 19.6342 20.5569 19.6477 20.5624L16.1875 18.5586V25.1645C16.1875 25.1645 20.6054 23.12 21.4765 21.6403H21.4792Z",
    fill: "#272E40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.77305 25.2043C8.2067 24.2974 7.24362 22.6196 7.24362 20.8059V17.1325L10.4872 19.0113V21.8594L16.1872 25.1608V18.5552L10.4872 15.2537L7.2842 13.3993L4 11.4961V21.1019C4 23.8956 5.48519 26.4776 7.89559 27.8758L10.0923 29.1492L16.1845 32.6787V28.9211L9.77305 25.2043Z",
    fill: "#3C4659"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3765 21.8633C28.3765 21.8633 27.2294 21.1981 25.5196 20.207C25.4195 21.6542 25.1517 23.3131 20.6499 26.3134C18.4612 27.7741 16.1914 28.9226 16.1914 28.9226V32.6803C16.1914 32.6803 21.0259 29.9706 22.2839 29.1507C28.1195 25.3522 28.3765 24.0598 28.3765 21.8633Z",
    fill: "#272E40"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1902 4.44119C16.9531 4.97877 19.3932 7.65035 25.1311 9.62146V16.2271L21.8875 14.3483V11.5003C18.3517 10.3654 16.1875 8.19879 16.1875 8.19879V14.8017C19.3013 16.6045 23.0129 18.7575 25.5153 20.2074C25.5153 20.1883 25.5153 20.1693 25.518 20.153C26.0888 20.5304 27.7525 21.4943 28.3693 21.8635V7.74266C21.0083 5.30457 16.9396 1.27547 16.1902 0.683594V4.44119Z",
    fill: "#2E936F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1846 14.8024V8.19922C16.1846 8.19922 13.9581 10.3686 10.4844 11.5008C10.736 11.6447 13.1789 13.062 16.1846 14.8024Z",
    fill: "#3DC289"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 7.74293L4.03788 7.76465H4V11.5007L7.28434 13.404V9.60823C12.8088 7.71578 15.782 4.80788 16.1851 4.44133V0.683594C15.7982 1.04199 11.5075 5.23415 4 7.74293Z",
    fill: "#3DC289"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5156 20.2066C27.2254 21.1977 28.3725 21.8629 28.3725 21.8629C27.7557 21.4936 26.0919 20.5297 25.521 20.1523C25.521 20.1713 25.521 20.1904 25.5183 20.2066H25.5156Z",
    fill: "#3DC289"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAntiscam);
export default __webpack_public_path__ + "static/media/ico_antiscam.92bb63727671aa784639759cd90af4eb.svg";
export { ForwardRef as ReactComponent };